'use strict';


import { Effect } from './Effect';
import { FullScreenQuad, Pass } from 'three/examples/jsm/postprocessing/Pass';
import {
	Color,
	ShaderMaterial,
	UniformsUtils,
	WebGLRenderTarget,
} from 'three';
import { CopyShader } from 'three/examples/jsm/shaders/CopyShader';
import vertex from '../Passes/Shaders/CylinderAnimation/vertex.glsl';
import fragment from '../Passes/Shaders/CylinderAnimation/fragment.glsl';
import { threeJsVariables } from '../../../settings';

export class CylinderAnimation extends Effect{
	constructor (camera,width,height) {
		super();
		
		this.effect = new CylinderPass(camera,width,height);
		this.active = false;
	}
	
	setProgress(value) {
		this.effect.setProgress(value);
	}
}

class CylinderPass extends Pass{
	constructor (camera,width,height) {
		super();
		this.width = width;
		this.height = height;
		this.camera = camera;
		
		this.mainLayer = new ShaderMaterial({
			uniforms: UniformsUtils.clone(CopyShader.uniforms),
			vertexShader: CopyShader.vertexShader,
			fragmentShader: CopyShader.fragmentShader,
			transparent: true,
			depthTest: false,
			depthWrite: false
		});
		
		this.mainRt = new WebGLRenderTarget(this.width,this.height);
		this.secondRt = new WebGLRenderTarget(this.width,this.height);
		
		this.mixedLayer = new ShaderMaterial({
			uniforms: {
				mainLayer: { value: this.mainRt.texture },
				secondLayer: { value: this.secondRt.texture },
				progress: { value: 0.0 }
			},
			vertexShader: vertex,
			fragmentShader: fragment,
			transparent: true,
			depthWrite: false,
			depthTest: false
		});
		
		this.fsQuad = new FullScreenQuad(null);
		this.originalClearColor = new Color();
		this.needsSwap = false;
	}
	
	setProgress(value) {
		this.mixedLayer.uniforms.progress.value = value;
	}
	
	setSize( width, height) {
		this.width = width;
		this.height = height;
		this.mainRt.setSize(width,height);
		this.secondRt.setSize(width,height);
	}
	
	render( renderer, writeBuffer, readBuffer) {
		this.mainLayer.uniforms.tDiffuse.value = readBuffer.texture;
		this.renderPass(renderer,this.mainLayer,this.mainRt);
		
		this.camera.layers.set(1);
		this.secondRt.samples = readBuffer.samples;
		renderer.setRenderTarget(this.secondRt);
		renderer.render(threeJsVariables.scene,this.camera);
		this.camera.layers.enableAll();
		
		this.renderPass(renderer,this.mixedLayer,this.renderToScreen ? null : readBuffer);
	}
	
	renderPass( renderer, passMaterial, renderTarget, clearColor, clearAlpha ) {
		// save original state
		renderer.getClearColor( this.originalClearColor );
		const originalClearAlpha = renderer.getClearAlpha();
		const originalAutoClear = renderer.autoClear;
		
		renderer.setRenderTarget( renderTarget );
		
		// setup pass state
		renderer.autoClear = false;
		if ( ( clearColor !== undefined ) && ( clearColor !== null ) ) {

			renderer.setClearColor( clearColor );
			renderer.setClearAlpha( clearAlpha || 0.0 );
			renderer.clear();

		}
		
		this.fsQuad.material = passMaterial;
		this.fsQuad.render( renderer );
		
		// restore original state
		renderer.autoClear = originalAutoClear;
		renderer.setClearColor( this.originalClearColor );
		renderer.setClearAlpha( originalClearAlpha );
		
	}
}